<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
};
</script>

<style>
#app {
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-family: 'PingFang SC', '微软雅黑', Arial, sans-serif !important;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
a {
  cursor: pointer;
}
</style>
